import React from 'react';
import { CircularProgress, Stack, SxProps, Theme } from '@mui/material';

interface Props {
  size?: React.ComponentProps<typeof CircularProgress>['size'];
  sx?: SxProps<Theme>;
}

function PageLoading({ size, sx }: Props) {
  return (
    <Stack
      width="100%"
      justifyContent="center"
      alignItems="center"
      boxSizing="border-box"
      sx={sx}>
      <CircularProgress color="primary" size={size} />
    </Stack>
  );
}

export default PageLoading;
